import { formatIsoDate } from './dateCore';

export function todayIso(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return formatIsoDate(d);
}

/** 42-cell (6×7) month grid starting on the locale's first weekday. */
export function buildMonthGrid(year: number, month: number, first: 0 | 1): Date[] {
  const firstOfMonth = new Date(year, month, 1);
  const offset = (firstOfMonth.getDay() - first + 7) % 7;
  const start = new Date(year, month, 1 - offset);
  return Array.from({ length: 42 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    return d;
  });
}
